module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-15.11939960.jpg";